import React from "react";
import { useNavigate } from "react-router-dom";

function Header({ userName, userRole, setUserName, setUserRole }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("userName");
    localStorage.removeItem("userRole");
    localStorage.removeItem("token");
    localStorage.removeItem("userId");

    if (setUserName) setUserName("");
    if (setUserRole) setUserRole("");

    navigate("/login");
  };

  // Use state first, fallback to localStorage
  const displayName = userName || localStorage.getItem("userName") || "Guest";
  const displayRole = userRole || localStorage.getItem("userRole") || "";

  return (
    <header
      style={{
        backgroundColor: "#ffffff",
        color: "#5b5d5e",
        fontWeight: "bold",
        padding: "5px 20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderRadius: "0 0 8px 8px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
        minHeight: "60px",
        fontFamily: "Roboto, Arial, sans-serif",
      }}
    >
      {/* Logo */}
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="/Logo.png"
          alt="Logo"
          style={{ height: "70px", marginRight: "12px" }}
        />
      </div>

      {/* Center Welcome Message */}
      <div
        style={{
          textAlign: "center",
          flexGrow: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "70px",
        }}
      >
        <span style={{ fontSize: "15px", whiteSpace: "nowrap" }}>
          {displayName !== "Guest"
            ? `Welcome, ${displayName} you’re signed in as ${displayRole?.toUpperCase()}`
            : "Hello, Guest"}
        </span>
      </div>

      {/* Logout Button */}
      <button
        onClick={handleLogout}
        style={{
          backgroundColor: "#E30016",
          border: "none",
          color: "white",
          padding: "8px 16px",
          borderRadius: "10px",
          cursor: "pointer",
          fontWeight: "bold",
          fontSize: "14px",
          transition: "all 0.3s ease",
        }}
        onMouseOver={(e) => (e.target.style.backgroundColor = "#ff4d4d")}
        onMouseOut={(e) => (e.target.style.backgroundColor = "#E30016")}
      >
        Logout
      </button>
    </header>
  );
}

export default Header;
